import { render, staticRenderFns } from "./ClassesSubjects.vue?vue&type=template&id=1dd737fa"
import script from "./ClassesSubjects.vue?vue&type=script&lang=js"
export * from "./ClassesSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports